import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { getFileName } from '../helper/getFileName';
import { setReturnTicket } from '../helper/pageFilterPersistence';

const SRV_TICKET_KEY = "srv_return_from_details";
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function ServiceCardItem({ service, translate }) {
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const [windowWidtht, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <Link
            to={`/singleservice?id=${service.id}&title=${encodeURIComponent(service.serviceName || service.name)}`}
            onClick={() => setReturnTicket(SRV_TICKET_KEY)}
            className="col-xl-3 col-lg-4 col-md-6 col-sm-12 text-dark text-start scaleHoverEffect"
            style={{ marginBottom: windowWidtht >= 1400 ? 20 : '1.5rem' }}
        >
            <div className='w-100 bg-white position-relative h-100 p-main p-3' style={{ borderRadius: 15 }}>
                <span
                    className="second_service_section_category end-0 rtl"
                    style={currentLanguage === 'ar' ? { borderTopRightRadius: 15, borderBottomRightRadius: 15, fontSize: 12 } : { borderTopLeftRadius: 15, fontSize: 12, borderBottomLeftRadius: 15 }}
                >
                    {service.feesAmount > 0 ? (
                        <>
                            <span className='fw-bold' style={{ fontSize: 10 }}>{service.feesAmount.toLocaleString('en-US')}</span>
                            {" " + translate('web.aed', 'AED')}
                        </>
                    ) : (
                        translate('web.freeService', 'Free Service')
                    )}
                </span>
                {service?.serviceIcon ? (
                    <img
                        className='mt-1'
                        src={`${MediaBaseURL}${service?.serviceIcon}`}
                        alt={getFileName(service?.serviceIcon)}
                        style={{ width: 44 }}
                    />
                ) : service?.serviceImage ? (
                    <img
                        className='mt-1'
                        src={`${MediaBaseURL}${service?.serviceImage}`}
                        alt={getFileName(service?.serviceImage)}
                        style={{ width: 44 }}
                    />
                ) : null}
                <div className="bold" style={{ fontSize: 15, color: '#000000', marginTop: 28, width: '95%' }}>
                    {service.serviceName}
                </div>
                <div className="" style={{ fontSize: 12, color: '#838383', width: '95%', marginTop: 8 }}>
                    {service.subTitle}
                </div>
            </div>
        </Link>
    );
}
